import axios from "axios";

// On-demand AI summary for a single cluster — backs the "✦ Përmblidh" button.
// GET /api/cluster-summary?category=...&cluster_id=...
//   → { summary: string, cached: boolean }
//
// Generous timeout because a cache MISS triggers a live Groq call (~2-4s),
// and a Render cold start can add more on the first request.

export const fetchClusterSummary = async (category, clusterId) => {
  const res = await axios.get(
    `${process.env.REACT_APP_API_URL}/api/cluster-summary`,
    {
      params: { category, cluster_id: clusterId },
      timeout: 45000,
    }
  );
  return res.data; // { summary, cached }
};
